<div class="views-container">
  @if (busy) {
    <div class="overlay">
      <div class="center">
        <mat-spinner>
        </mat-spinner>
      </div>
    </div>
  }
  <h3 class="w-100 text-center">Views</h3>
  <table mat-table [dataSource]="views" class="views-table table-stack-sm w-100">
    <ng-container matColumnDef="fullName">
      <td mat-cell *matCellDef="let item" class="stack-first">
        <!-- no user id (client users, anonymous viewers): name only, no contact details -->
        @if(item.userId){
          <a href="#" (click)="onUserInfo(item);$event.preventDefault();" matTooltip="User Info">
              <span class="primary-color">{{item.fullName}}: </span>
          </a>
        }
        @else{
          <span>{{item.fullName}}: </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="views">
      <td mat-cell *matCellDef="let item" class="stack-last"> {{item.views}} view@if(item.views!=1){s}; last on: {{item.lastViewedDate | date:'short'}} </td>
    </ng-container>

    <ng-container matColumnDef="isFavorite">
      <td mat-cell *matCellDef="let item" class="stack-first stack-end">@if(item.isFavorite){<mat-icon class="red-color" matTooltip="User Favorite">favorite</mat-icon>}</td>
    </ng-container>

    <tr mat-row *matRowDef="let item; columns: displayedColumns;"></tr>
  </table>
</div>
    
